<script>
    export let text;
    export let style;
    export let iconPath;
    export let isActive;
    export let title = undefined;
    export let disabled = false;
    export let doLocalizeText = true;
    let _class = "";
    export { _class as class };
</script>

<button
    class={`button-wrapper ${_class} ${isActive ? "is-active" : ""}`}
    {style}
    {disabled}
    {title}
    on:click
    {...$$restProps}
>
    <div class="button-inner">
        {#if iconPath}<div
                class="icon"
                style={`background-image: url('ui/icons/${iconPath}')`}
            />{/if}
        <span class="button-text">
            {doLocalizeText ? globalThis.i18n(text) : text}
        </span>
    </div>
</button>

<style>
    button:disabled {
        cursor: not-allowed;
    }
    .button-inner {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
    }
    .justify-center .button-inner {
        justify-content: center;
    }
    .justify-center .button-text {
        width: 100%;
    }
    .icon {
        background-repeat: no-repeat;
        background-size: cover; /* Make the image cover the div */
        background-position: 50%; /* Center the image inside the div */
        margin-right: 8px;
    }
    .button-text {
        white-space: nowrap;
        margin-right: 8px;
    }
</style>
